import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const Header = styled.header`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const LogoImage = styled.img`
    max-height: 48px;
    max-width: 180px;
    object-fit: contain;
`;

export const HeroSection = styled.div`
    width: 100%;
    padding: 20px 24px 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 26px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.3;
    white-space: pre-line;

    strong {
        font-weight: 800;
    }
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
`;

export const DisclaimerSection = styled.div`
    width: 100%;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DisclaimerText = styled.p`
    font-size: 11px;
    color: #718096;
    margin: 0;
    line-height: 1.5;
`;

export const CheckboxWrapper = styled.div`
    width: 100%;
    padding: 16px 20px 24px;
`;

export const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 20px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
`;

export const DataCardContainer = styled.div`
    width: 100%;
    padding: 0 20px;
`;